<template>
    <div class="home-page">
        <home-page-top></home-page-top>
        <home-page-intro></home-page-intro>
      <section id="bikes-series">
        <home-page-bikes-desktop></home-page-bikes-desktop>
        <home-page-bikes-mobile></home-page-bikes-mobile>
      </section>
        <home-page-warranty></home-page-warranty>


    </div>
</template>
<script>
import HomePageTop from './Top.vue'
// import HomePageTop from './BlackFriday.vue'
import HomePageWarranty from './Warranty.vue'
import HomePageIntro from './Intro.vue'
import HomePageBikesDesktop from './BikesSeriesDesktop.vue'
import HomePageBikesMobile from './BikesSeriesMobile.vue'
import Download from '../Blocks/Download.vue'
import $ from 'jquery'

export default {
  name: 'HomePage',
  components: {
    HomePageTop,
    HomePageIntro,
    HomePageBikesDesktop,
    HomePageBikesMobile,
    HomePageWarranty,
    Download
  },
  mounted: function () {
    $(document).ready(function () {
      $('.home .mobile.series-accordion').roll({speed: 200})
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/HomePage.vue